import { useEffect, useState, useCallback } from "react";
import { getUsersByCompany } from "../services/masterDataService";

export const useUsers = (domain,company) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    if (!domain) {
      setUsers([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getUsersByCompany(domain,company);  
       var userOptions = data?.map(function (c) {
          return {
            value: c.userId,
            label: `${c.userName} - ${c.userId}`,
          };
        });

      setUsers(userOptions);
    } catch (err) {
      console.error(`Failed to load users for company ${company}:`, err);
      setError(err.message || "Failed to load users");
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [domain,company]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error };
};